<div class="spacer" [style.height.px]="getHeight()"></div>
